import React, { useCallback, useEffect } from 'react';

import { useTheme } from '@bcp-nextgen-dx-component-factory/design-system';
import { SegmentedProgressBarRef } from '@bcp-nextgen-dx-component-factory/design-system';
import { useCarouselDetails } from '@hooks';
import { IntroDetailsResources } from '@types';

export interface IntroHelperOutput {
	cerise: string;
	segmentedProgressBarRef: React.RefObject<SegmentedProgressBarRef>;
	carousel: IntroDetailsResources[];
	activeIndex: number;
	activeCarousel: IntroDetailsResources;
	carouselLength: number;
	timeAnimation: () => number;
	resetCarousel: (() => void) | undefined;
	onChangeSegmentedProgressBar: (index: number) => void;
	paddingRightIcon: (index: number) => number;
}

export const useIntroHelper = (): IntroHelperOutput => {
	const { colorPalette } = useTheme();

	const [activeIndex, setActiveIndex] = React.useState<number>(0);
	const segmentedProgressBarRef = React.useRef<SegmentedProgressBarRef>(null);
	// const segmentedProgressBarRef = React.useRef<SegmentedProgressBarRef>(null);

	const carousel = useCarouselDetails();

	const cerise = colorPalette.color_02[100];

	const activeCarousel = carousel[activeIndex];

	const carouselLength = carousel.length;

	const paddingRightIcon = useCallback((index: number) => {
		return index + 1 !== activeCarousel?.icon?.length ? 36 : 0;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const timeAnimation = useCallback(() => {
		const time = parseInt(carousel[activeIndex]?.timeAnimation);
		return !isNaN(time) ? time * 1000 : 10000;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeIndex]);

	const onChangeSegmentedProgressBar = useCallback((index: number) => setActiveIndex(index), []);

	const resetCarousel = segmentedProgressBarRef.current?.reset;

	useEffect(() => {
		return () => {
			setActiveIndex(0);
		};
	}, []);

	return {
		cerise,
		segmentedProgressBarRef,
		carousel,
		activeIndex,
		activeCarousel,
		carouselLength,
		timeAnimation,
		resetCarousel,
		onChangeSegmentedProgressBar,
		paddingRightIcon,
	};
};
